import z from "zod";

export interface Route {
  path: string;
  component: string;
  label: string;
  icon: string;
  _id?: number | string;
}

export const CustomInputScopeSchema = z
  .object({
    customInputId: z.union([z.number(), z.string()]).optional(),
    /** Keep `string[]` here for RHF + `tsc` — coerce numeric ids in `normalizeCustomInputScopesForForm`. */
    optionIds: z.array(z.string()).optional(),
    textValue: z.string().optional(),
  })
  .passthrough();
